<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!armour().show" (click)="toggleShowArmour()"></button>
  </span>
  <span class="filter-body" [class.equipment-filter-from-preset]="armour().fromProgressPreset || armour().fromClassPreset">
    <app-autocomplete
      [allowAll]="false"
      [options]="armourTypes"
      [disabled]="!armour().show"
      [showOptions]="true"
      [selectedValues]="armour().armourType"
      (selectedValuesChange)="armourTypeChanged($event);"></app-autocomplete>
    <span class="sep"></span>
    <app-autocomplete
      [allowAll]="false"
      [options]="defenceTypes"
      [disabled]="!armour().show"
      [showOptions]="true"
      [selectedValues]="armour().defenceType"
      (selectedValuesChange)="defenceTypeChanged($event);"></app-autocomplete>
    <!-- <span class="sep"></span>
    <app-select-comparator [(ngModel)]="armour().rarityComparator" [allowLessThanOrEqual]="false" (selectedValueChange)="updateFilter()" [disabled]="!armour().show"></app-select-comparator> -->
    <span class="sep"></span>
    <app-select-rarity [greaterThanOrEqualTo]="true" [includeUnique]="false" [disabled]="!armour().show" [(ngModel)]="armour().rarity" (selectedValueChange)="minRarityChanged($event);"></app-select-rarity>
    <span class="sep"></span>
    @if (armour().baseTypeMode === GearBaseTypeMode.Tier) {
      <app-select-gear-tier [greaterThanOrEqualTo]="true" [disabled]="!armour().show" [(ngModel)]="armour().baseTypeTier" (selectedValueChange)="updateFilter();"></app-select-gear-tier>
    } @else {
      <app-autocomplete
        class="my-gear-base-types-autocomplete"
        [allowAll]="true"
        [options]="specificBaseTypeAutocompleteOptions()"
        [disabled]="!armour().show"
        [showOptions]="true"
        [selectedValues]="armour().specificBaseTypes"
        (selectedValuesChange)="specificArmourBaseTypesChanged($event)"></app-autocomplete>
    }
    <span class="sep"></span>
    <span class="input-group-btn">
      <app-tooltip-wrapper [right]="true">
        <button type="button" class="btn toggle-button customize-btn" [class.active]="armour().baseTypeMode === GearBaseTypeMode.Specific" [disabled]="!armour().show"
          (click)="toggleArmourBaseTypeMode()">
          <span class="icon icon-filter"></span>
          <span class="label">{{ armour().baseTypeMode === GearBaseTypeMode.Tier || armour().specificBaseTypes[0] === 'All' ? '' : armour().specificBaseTypes.length }}</span>
        </button>
        <ng-template #tooltip>
          {{ armour().baseTypeMode === GearBaseTypeMode.Tier
            ? 'Switch to specifying specific base types instead of minimum Gear Tier. Useful for the Recombinator.'
            : 'Switch to specifying minimum Gear Tier instead of specific base types' }}
        </ng-template>
      </app-tooltip-wrapper>
    </span>
    @if (poe2) {
      <span class="sep"></span>
      <app-select style="width: 65px" [disabled]="!armour().show" [(ngModel)]="armour().unidentifiedTier" (selectedValueChange)="minUnidentifiedTierChanged($event);">
        <app-option [value]="undefined" [text]="'Any'"></app-option>
        <app-option [value]="2" [text]="'≥ T2'"></app-option>
        <app-option [value]="3" [text]="'≥ T3'"></app-option>
        <app-option [value]="4" [text]="'≥ T4'"></app-option>
        <app-option [value]="5" [text]="'T5'"></app-option>
      </app-select>
    } @else {
      <span class="sep"></span>
      <app-select style="width: 65px" [disabled]="!armour().show" [(ngModel)]="armour().minLinks" (selectedValueChange)="updateFilter();">
        <app-option [value]="undefined" [text]="'Any'"></app-option>
        <app-option [value]="'2'" [text]="'≥ 2L'"></app-option>
        <app-option [value]="'3'" [text]="'≥ 3L'"></app-option>
        <app-option [value]="'4'" [text]="'≥ 4L'"></app-option>
        <app-option [value]="'5'" [text]="'≥ 5L'"></app-option>
        <app-option [value]="'6'" [text]="'6L'"></app-option>
      </app-select>
    }
    <span class="sep"></span>
    <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" style="min-width: 55px;"
      [disabled]="!armour().show"
      [(ngModel)]="armour().itemLevel" (change)="updateFilter()">
    @if (poe1) {
      <span class="sep"></span>
      <span class="input-group-btn">
        <button class="btn toggle-button customize-btn" [class.no-conditions]="hasAdvancedConditions === 0" [class.active]="advancedConditionsOpen" [class.disabled]="!armour().show"
          (click)="toggleAdvancedOptionsOpen()">
          <span class="icon icon-cog"></span>
          <span class="label">{{ hasAdvancedConditions }}</span>
        </button>
      </span>
    }
    <span class="sep"></span>
    <span class="input-group-btn">
      <app-tooltip-wrapper [right]="true">
        <button class="btn toggle-button customize-btn" [class.no-conditions]="hasHighlightConfig === 0" [class.active]="highlightConfigOpen" [class.disabled]="!armour().show"
          (click)="toggleHighlightConfigOpen()">
          <span class="icon icon-equalizer"></span>
          <span class="label">{{ hasHighlightConfig }}</span>
        </button>
        <ng-template #tooltip>Configure which Variants ({{ poe2 ? 'like Unidentified Tiered Armour or Exceptional Armour' : 'like Armour with Memory Strands'}}) of your chosen Armour Type(s) should be shown and highlighted.</ng-template>
      </app-tooltip-wrapper>
    </span>
    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn remove-btn" (click)="removeArmourType()"></button>
    </span>
  </span>
</div>
@if (poe1 && advancedConditionsOpen) {
  <app-advanced-equipment-conditions
    [isArmour]="true"
    [advancedConditions]="armour()"
    [isActive]="armour().show"
    (updateFilterEmitter)="hasAdvancedConditions = getNumberOfAdvancedConditions(); updateFilter()"></app-advanced-equipment-conditions>
  <div class="clear"></div>
}

@if (navigationEnabled || highlightConfigOpen) {
  <div [class.collapsed]="!highlightConfigOpen">
    <app-my-equipment-highlights
      [equipment]="armour()"
      [gearOrJewellery]="armour()"
      [gear]="armour()"
      [equipmentType]="'armour'"
      [equipmentIndex]="index()"
      (updateFilterEmitter)="hasHighlightConfig = getNumberOfHighlightConfig(); updateFilter()"></app-my-equipment-highlights>
    <div class="clear"></div>
  </div>
}
